import $ from '../tools/Dom';

export default (el, data) => {
    const poster = $(el).find('[data-video-poster]').get(0);
    const embed = $(el).find('[data-video-embed]').get(0);

    const { embedCode } = data;

    let hasClicked = false;

    const onThumbClick = e => {
        e.preventDefault();
        if (hasClicked) {
            return;
        }
        hasClicked = true;
        $(embed).html(embedCode);
        requestAnimationFrame(() => {
            TweenMax.to(poster, 0.65, { ease: Sine.easeIn,
                opacity: 0,
                onComplete: () => {
                    poster.hidden = true;
                } });
        });
    };

    const init = () => {
        $(poster).on('click', onThumbClick);
    };

    const destroy = () => {
        $(poster).off('click');
    };

    return {
        init,
        destroy
    };
};
